import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const OutdoorIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "OutdoorIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5177 2L22.2571 15.5527C22.2488 15.9842 21.8923 16.3273 21.4608 16.319C21.0293 16.3107 20.6862 15.9542 20.6945 15.5226L20.722 14.0898L11.6634 13.9547L10.7916 14.8262C9.87604 15.7416 8.39158 15.7417 7.47609 14.8261L5.81837 13.1684C5.51317 12.8632 5.01837 12.8633 4.71324 13.1684C4.40805 13.4736 4.40804 13.9684 4.71322 14.2736L8.02874 17.5891C8.94428 18.5047 8.94431 19.9891 8.02874 20.9046L7.48593 21.4474C7.18075 21.7526 6.68595 21.7526 6.38076 21.4474C6.07558 21.1422 6.07558 20.6474 6.38076 20.3422L6.92357 19.7994C7.22872 19.4943 7.22876 18.9995 6.92357 18.6943L3.60805 15.3788C2.6925 14.4632 2.6925 12.9788 3.60803 12.0633C4.52356 11.1477 6.008 11.1477 6.92354 12.0633L8.58128 13.721C8.88641 14.0261 9.38123 14.0262 9.68643 13.721L10.558 12.8498L10.4276 3.79573L8.9951 3.82328C8.56358 3.83158 8.20704 3.48849 8.19874 3.05698C8.19044 2.62546 8.53353 2.26892 8.96505 2.26062L22.5177 2ZM11.9902 3.76568L12.0989 11.3096L15.6574 7.75271L14.0009 6.09619L15.106 4.99102L16.7628 6.64779L19.7964 3.61557L11.9902 3.76568ZM20.9022 4.7201L17.868 7.75296L19.5267 9.41169L18.4215 10.5169L16.7626 8.85788L13.2042 12.4146L20.7521 12.5271L20.9022 4.7201Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default OutdoorIcon;
